import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { InfoPanel } from '../components/InfoPanel';
import type { ApiKeySummary, MbtilesEntry, ReadTokenSummary } from '../api/types';

export function DashboardPage() {
  const [mbtiles, setMbtiles] = useState<MbtilesEntry[] | null>(null);
  const [keys, setKeys] = useState<ApiKeySummary[] | null>(null);
  const [tokens, setTokens] = useState<ReadTokenSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    Promise.all([api.listMbtiles(), api.listApiKeys(), api.listReadTokens()])
      .then(([m, k, t]) => {
        if (!alive) return;
        setMbtiles(m);
        setKeys(k);
        setTokens(t);
      })
      .catch((err) => alive && setError((err as Error).message));
    return () => {
      alive = false;
    };
  }, []);

  if (error) return <div className="banner error">{error}</div>;
  if (!mbtiles || !keys || !tokens) return <div>로딩 중…</div>;

  const publicCount = mbtiles.filter((m) => m.public).length;
  const privateCount = mbtiles.length - publicCount;
  const activeKeys = keys.filter((k) => !k.revokedAt).length;
  const activeTokens = tokens.filter((t) => !t.revokedAt).length;

  return (
    <>
      <h2>대시보드</h2>
      <InfoPanel
        what={
          <p style={{ margin: 0 }}>
            mbtiler 인스턴스의 현황을 한 눈에 보여줍니다 — 등록된 mbtiles 수와
            public/private 분포, 활성 API key 와 read-token 개수.
          </p>
        }
        why={
          <p style={{ margin: 0 }}>
            로그인 직후 "현재 어떤 자원이 얼마나 살아있는지" 빠르게 파악하고,
            예상과 다른 수치가 보이면 (예: 활성 토큰이 갑자기 0) 곧장 해당 메뉴로
            들어가 점검하기 위해.
          </p>
        }
      />
      <div className="metric-grid">
        <Metric label="mbtiles 전체" value={mbtiles.length} />
        <Metric label="public" value={publicCount} />
        <Metric label="private" value={privateCount} />
        <Metric label="API key (활성)" value={activeKeys} />
        <Metric label="read-token (활성)" value={activeTokens} />
      </div>
    </>
  );
}

function Metric({ label, value }: { label: string; value: number }) {
  return (
    <div className="metric">
      <div className="label">{label}</div>
      <div className="value">{value}</div>
    </div>
  );
}
